export const shortUserId = (id, length = 8) => {
  if (!id) return '—';
  return `...${String(id).slice(-length)}`;
};

export const getUserDisplayLabel = ({
  id,
  displayName,
  isOwn,
  ownLabel = 'You',
} = {}) => {
  if (isOwn) return ownLabel;
  const trimmedName = typeof displayName === 'string' ? displayName.trim() : '';
  return trimmedName || shortUserId(id);
};
